// src/components/NotFoundPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* Animated 404 Number */}
                <div className={styles.numberContainer}>
                    <div className={styles.numberGlow}></div>
                    <div className={styles.number}>
                        4
                        <div className={styles.zero}>
                            <div className={styles.zeroInner}></div>
                            <div className={styles.zeroRing}></div>
                        </div>
                        4
                    </div>
                </div>

                {/* Title and Message */}
                <h1 className={styles.title}>{t('pages.notFound.title')}</h1>
                <p className={styles.message}>
                    {t('pages.notFound.message')}
                </p>

                {/* Action Buttons */}
                <div className={styles.actions}>
                    <button
                        onClick={() => navigate(-1)}
                        className={`${styles.button} ${styles.buttonSecondary}`}
                    >
                        {t('pages.notFound.back')}
                    </button>
                    <button
                        onClick={() => navigate('/dashboard')}
                        className={`${styles.button} ${styles.buttonPrimary}`}
                    >
                        {t('pages.notFound.dashboard')}
                    </button>
                </div>

                {/* Suggestions */}
                <div className={styles.suggestions}>
                    <p className={styles.suggestionsTitle}>{t('pages.notFound.suggestions')}</p>
                    <div className={styles.suggestionsList}>
                        <span onClick={() => navigate('/dashboard')}>{t('navigation.dashboard')}</span>
                        <span onClick={() => navigate('/cadastros/produtos')}>{t('navigation.registrations')}</span>
                        <span onClick={() => navigate('/pedidos/pedido-de-venda')}>{t('navigation.orders')}</span>
                        <span onClick={() => navigate('/estoque/embalagens/consulta-de-estoque')}>{t('navigation.inventory')}</span>
                    </div>
                </div>

                {/* Decorative Elements */}
                <div className={styles.decoration1}></div>
                <div className={styles.decoration2}></div>
                <div className={styles.decoration3}></div>
                <div className={styles.decoration4}></div>
            </div>
        </div>
    );
};

export default NotFoundPage;